import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router';
import { useAuthStore } from '@/features/auth/store';
import { isAdminRole } from '@/features/auth/constants';
export function ProtectedRoute() {
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
    const role = useAuthStore((s) => s.user?.role);
    // Defense-in-depth behind the backend 403: require both authentication and
    // the admin role. Non-admins never get a persisted session via useLogin, so
    // this mainly guards stale/edge sessions.
    if (!isAuthenticated || !isAdminRole(role)) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    return _jsx(Outlet, {});
}
